/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: irBak36DUa2B

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeTopSection.module.css"; // plasmic-import: irBak36DUa2B/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicHomeTopSection__VariantMembers = {};
export type PlasmicHomeTopSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeTopSection__VariantsArgs;
export const PlasmicHomeTopSection__VariantProps = new Array<VariantPropType>();

export type PlasmicHomeTopSection__ArgsType = { onContactClick?: () => void };
type ArgPropType = keyof PlasmicHomeTopSection__ArgsType;
export const PlasmicHomeTopSection__ArgProps = new Array<ArgPropType>(
  "onContactClick"
);

export type PlasmicHomeTopSection__OverridesType = {
  topSection?: Flex__<"section">;
  desktop?: Flex__<"div">;
  banner?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  col?: Flex__<"div">;
  sectionHeader?: Flex__<"header">;
  top?: Flex__<"div">;
  subtitle?: Flex__<"h4">;
  title?: Flex__<"h1">;
  body3?: Flex__<"div">;
  body?: Flex__<"p">;
  body4?: Flex__<"p">;
  actions?: Flex__<"div">;
  requestDemo?: Flex__<typeof Button>;
  contact?: Flex__<typeof Button>;
  desktopMockup?: Flex__<typeof PlasmicImg__>;
  clients?: Flex__<"div">;
  wrapper2?: Flex__<"div">;
  rows?: Flex__<"div">;
  row?: Flex__<"div">;
  _5?: Flex__<"div">;
  _7?: Flex__<"div">;
  _8?: Flex__<"div">;
  _9?: Flex__<"div">;
  row2?: Flex__<"div">;
  _6?: Flex__<"div">;
  _10?: Flex__<"div">;
  _11?: Flex__<"div">;
  _12?: Flex__<"div">;
  tablet?: Flex__<"div">;
  banner3?: Flex__<"div">;
  wrapper3?: Flex__<"div">;
  col2?: Flex__<"div">;
  sectionHeader3?: Flex__<"div">;
  top2?: Flex__<"div">;
  subtitle3?: Flex__<"h4">;
  title3?: Flex__<"h1">;
  body7?: Flex__<"div">;
  body8?: Flex__<"p">;
  body9?: Flex__<"p">;
  actions3?: Flex__<"div">;
  requestDemo3?: Flex__<typeof Button>;
  contact3?: Flex__<typeof Button>;
  desktopMockup2?: Flex__<typeof PlasmicImg__>;
  clients3?: Flex__<"div">;
  wrapper4?: Flex__<"div">;
  rows2?: Flex__<"div">;
  row3?: Flex__<"div">;
  _21?: Flex__<"div">;
  _22?: Flex__<"div">;
  _23?: Flex__<"div">;
  _24?: Flex__<"div">;
  row5?: Flex__<"div">;
  _25?: Flex__<"div">;
  _26?: Flex__<"div">;
  _27?: Flex__<"div">;
  _28?: Flex__<"div">;
  mobile?: Flex__<"div">;
  banner2?: Flex__<"div">;
  sectionHeader2?: Flex__<"div">;
  top3?: Flex__<"div">;
  subtitle2?: Flex__<"h4">;
  title2?: Flex__<"h1">;
  body5?: Flex__<"div">;
  body2?: Flex__<"p">;
  body6?: Flex__<"p">;
  actions2?: Flex__<"div">;
  requestDemo2?: Flex__<typeof Button>;
  contact2?: Flex__<typeof Button>;
  clients2?: Flex__<"div">;
  top4?: Flex__<"div">;
  row4?: Flex__<"div">;
  left2?: Flex__<"div">;
  _13?: Flex__<"div">;
  _15?: Flex__<"div">;
  _17?: Flex__<"div">;
  _19?: Flex__<"div">;
  right2?: Flex__<"div">;
  _14?: Flex__<"div">;
  _16?: Flex__<"div">;
  _18?: Flex__<"div">;
  _20?: Flex__<"div">;
};

export interface DefaultHomeTopSectionProps {
  onContactClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeTopSection__RenderFunc(props: {
  variants: PlasmicHomeTopSection__VariantsArgs;
  args: PlasmicHomeTopSection__ArgsType;
  overrides: PlasmicHomeTopSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"topSection"}
      data-plasmic-override={overrides.topSection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.topSection
      )}
    >
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : true
      ) ? (
        <div
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          className={classNames(projectcss.all, sty.desktop)}
        >
          <div
            data-plasmic-name={"banner"}
            data-plasmic-override={overrides.banner}
            className={classNames(projectcss.all, sty.banner)}
          >
            <div
              data-plasmic-name={"wrapper"}
              data-plasmic-override={overrides.wrapper}
              className={classNames(projectcss.all, sty.wrapper)}
            >
              <div
                data-plasmic-name={"col"}
                data-plasmic-override={overrides.col}
                className={classNames(projectcss.all, sty.col)}
              >
                <header
                  data-plasmic-name={"sectionHeader"}
                  data-plasmic-override={overrides.sectionHeader}
                  className={classNames(projectcss.all, sty.sectionHeader)}
                >
                  <div
                    data-plasmic-name={"top"}
                    data-plasmic-override={overrides.top}
                    className={classNames(projectcss.all, sty.top)}
                  >
                    <h4
                      data-plasmic-name={"subtitle"}
                      data-plasmic-override={overrides.subtitle}
                      className={classNames(
                        projectcss.all,
                        projectcss.h4,
                        projectcss.__wab_text,
                        sty.subtitle
                      )}
                    >
                      {"The human approach to medical education"}
                    </h4>
                    <h1
                      data-plasmic-name={"title"}
                      data-plasmic-override={overrides.title}
                      className={classNames(
                        projectcss.all,
                        projectcss.h1,
                        projectcss.__wab_text,
                        sty.title
                      )}
                    >
                      {"Excellence beyond Compliance"}
                    </h1>
                  </div>
                  <div
                    data-plasmic-name={"body3"}
                    data-plasmic-override={overrides.body3}
                    className={classNames(projectcss.all, sty.body3)}
                  >
                    <p
                      data-plasmic-name={"body"}
                      data-plasmic-override={overrides.body}
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.body
                      )}
                    >
                      {
                        "At MyEvaluations, cutting-edge technology with a human touch reshapes the way you manage medical education. "
                      }
                    </p>
                    <p
                      data-plasmic-name={"body4"}
                      data-plasmic-override={overrides.body4}
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.body4
                      )}
                    >
                      {
                        "Our intuitive suite of tools simplifies assessments, scheduling, curriculum management, and more, empowers you to achieve excellence in education."
                      }
                    </p>
                  </div>
                </header>
                <div
                  data-plasmic-name={"actions"}
                  data-plasmic-override={overrides.actions}
                  className={classNames(projectcss.all, sty.actions)}
                >
                  <Button
                    data-plasmic-name={"requestDemo"}
                    data-plasmic-override={overrides.requestDemo}
                    aria-label={"Request demo"}
                    className={classNames("__wab_instance", sty.requestDemo)}
                    color={
                      hasVariant(globalVariants, "mobile", "mobile")
                        ? "primary"
                        : "primary"
                    }
                    link={
                      "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                    }
                    size={"large"}
                    target={true}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__iqOzY
                      )}
                    >
                      {"Request demo"}
                    </div>
                  </Button>
                  <Button
                    data-plasmic-name={"contact"}
                    data-plasmic-override={overrides.contact}
                    aria-label={"Open contact modal"}
                    className={classNames("__wab_instance", sty.contact)}
                    color={"white"}
                    onClick={async event => {
                      const $steps = {};

                      $steps["runOnContactClick"] = true
                        ? (() => {
                            const actionArgs = {
                              eventRef: $props["onContactClick"]
                            };
                            return (({ eventRef, args }) => {
                              return eventRef?.(...(args ?? []));
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["runOnContactClick"] != null &&
                        typeof $steps["runOnContactClick"] === "object" &&
                        typeof $steps["runOnContactClick"].then === "function"
                      ) {
                        $steps["runOnContactClick"] =
                          await $steps["runOnContactClick"];
                      }
                    }}
                    size={"large"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__lMpbe
                      )}
                    >
                      {"Contact"}
                    </div>
                  </Button>
                </div>
              </div>
              <PlasmicImg__
                data-plasmic-name={"desktopMockup"}
                data-plasmic-override={overrides.desktopMockup}
                alt={""}
                className={classNames(sty.desktopMockup)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "725px"
                    : "850px"
                }
                loader={"plasmic"}
                loading={"eager"}
                src={{
                  src: "https://site-assets.plasmic.app/08c023a80e5a420a8b8ddd888afd2bb5.svg",
                  fullWidth: 870,
                  fullHeight: 768,
                  aspectRatio: 1.132813
                }}
              />
            </div>
          </div>
          <div
            data-plasmic-name={"clients"}
            data-plasmic-override={overrides.clients}
            className={classNames(projectcss.all, sty.clients)}
          >
            <div
              data-plasmic-name={"wrapper2"}
              data-plasmic-override={overrides.wrapper2}
              className={classNames(projectcss.all, sty.wrapper2)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qmkHk
                )}
              >
                {"Our Clients"}
              </div>
              <div
                data-plasmic-name={"rows"}
                data-plasmic-override={overrides.rows}
                className={classNames(projectcss.all, sty.rows)}
              >
                <div
                  data-plasmic-name={"row"}
                  data-plasmic-override={overrides.row}
                  className={classNames(projectcss.all, sty.row)}
                >
                  <div
                    data-plasmic-name={"_5"}
                    data-plasmic-override={overrides._5}
                    className={classNames(projectcss.all, sty._5)}
                  />

                  <div
                    data-plasmic-name={"_7"}
                    data-plasmic-override={overrides._7}
                    className={classNames(projectcss.all, sty._7)}
                  />

                  <div
                    data-plasmic-name={"_8"}
                    data-plasmic-override={overrides._8}
                    className={classNames(projectcss.all, sty._8)}
                  />

                  <div
                    data-plasmic-name={"_9"}
                    data-plasmic-override={overrides._9}
                    className={classNames(projectcss.all, sty._9)}
                  />
                </div>
                <div
                  data-plasmic-name={"row2"}
                  data-plasmic-override={overrides.row2}
                  className={classNames(projectcss.all, sty.row2)}
                >
                  <div
                    data-plasmic-name={"_6"}
                    data-plasmic-override={overrides._6}
                    className={classNames(projectcss.all, sty._6)}
                  />

                  <div
                    data-plasmic-name={"_10"}
                    data-plasmic-override={overrides._10}
                    className={classNames(projectcss.all, sty._10)}
                  />

                  <div
                    data-plasmic-name={"_11"}
                    data-plasmic-override={overrides._11}
                    className={classNames(projectcss.all, sty._11)}
                  />

                  <div
                    data-plasmic-name={"_12"}
                    data-plasmic-override={overrides._12}
                    className={classNames(projectcss.all, sty._12)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          className={classNames(projectcss.all, sty.tablet)}
        >
          <div
            data-plasmic-name={"banner3"}
            data-plasmic-override={overrides.banner3}
            className={classNames(projectcss.all, sty.banner3)}
          >
            <div
              data-plasmic-name={"wrapper3"}
              data-plasmic-override={overrides.wrapper3}
              className={classNames(projectcss.all, sty.wrapper3)}
            >
              <div
                data-plasmic-name={"col2"}
                data-plasmic-override={overrides.col2}
                className={classNames(projectcss.all, sty.col2)}
              >
                <div
                  data-plasmic-name={"sectionHeader3"}
                  data-plasmic-override={overrides.sectionHeader3}
                  className={classNames(projectcss.all, sty.sectionHeader3)}
                >
                  <div
                    data-plasmic-name={"top2"}
                    data-plasmic-override={overrides.top2}
                    className={classNames(projectcss.all, sty.top2)}
                  >
                    <h4
                      data-plasmic-name={"subtitle3"}
                      data-plasmic-override={overrides.subtitle3}
                      className={classNames(
                        projectcss.all,
                        projectcss.h4,
                        projectcss.__wab_text,
                        sty.subtitle3
                      )}
                    >
                      {"The human approach to medical education"}
                    </h4>
                    <h1
                      data-plasmic-name={"title3"}
                      data-plasmic-override={overrides.title3}
                      className={classNames(
                        projectcss.all,
                        projectcss.h1,
                        projectcss.__wab_text,
                        sty.title3
                      )}
                    >
                      {"Excellence beyond Compliance"}
                    </h1>
                  </div>
                  <div
                    data-plasmic-name={"body7"}
                    data-plasmic-override={overrides.body7}
                    className={classNames(projectcss.all, sty.body7)}
                  >
                    <p
                      data-plasmic-name={"body8"}
                      data-plasmic-override={overrides.body8}
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.body8
                      )}
                    >
                      {
                        "At MyEvaluations, cutting-edge technology with a human touch reshapes the way you manage medical education. "
                      }
                    </p>
                    <p
                      data-plasmic-name={"body9"}
                      data-plasmic-override={overrides.body9}
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.body9
                      )}
                    >
                      {
                        "Our intuitive suite of tools simplifies assessments, scheduling, curriculum management, and more, empowers you to achieve excellence in education."
                      }
                    </p>
                  </div>
                </div>
                <div
                  data-plasmic-name={"actions3"}
                  data-plasmic-override={overrides.actions3}
                  className={classNames(projectcss.all, sty.actions3)}
                >
                  <Button
                    data-plasmic-name={"requestDemo3"}
                    data-plasmic-override={overrides.requestDemo3}
                    aria-label={"Request demo"}
                    className={classNames("__wab_instance", sty.requestDemo3)}
                    color={
                      hasVariant(globalVariants, "mobile", "mobile")
                        ? "primary"
                        : "primary"
                    }
                    link={
                      "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                    }
                    size={"large"}
                    target={true}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___5T4X
                      )}
                    >
                      {"Request demo"}
                    </div>
                  </Button>
                  <Button
                    data-plasmic-name={"contact3"}
                    data-plasmic-override={overrides.contact3}
                    aria-label={"Open contact modal"}
                    className={classNames("__wab_instance", sty.contact3)}
                    color={"white"}
                    onClick={async event => {
                      const $steps = {};

                      $steps["runOnContactClick"] = true
                        ? (() => {
                            const actionArgs = {
                              eventRef: $props["onContactClick"]
                            };
                            return (({ eventRef, args }) => {
                              return eventRef?.(...(args ?? []));
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["runOnContactClick"] != null &&
                        typeof $steps["runOnContactClick"] === "object" &&
                        typeof $steps["runOnContactClick"].then === "function"
                      ) {
                        $steps["runOnContactClick"] =
                          await $steps["runOnContactClick"];
                      }
                    }}
                    size={"large"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__vdG90
                      )}
                    >
                      {"Contact"}
                    </div>
                  </Button>
                </div>
              </div>
              <PlasmicImg__
                data-plasmic-name={"desktopMockup2"}
                data-plasmic-override={overrides.desktopMockup2}
                alt={""}
                className={classNames(sty.desktopMockup2)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"578px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/a3747d9fa48494b0880f65934fc39f5b.svg",
                  fullWidth: 113,
                  fullHeight: 150,
                  aspectRatio: 0.752604
                }}
              />
            </div>
          </div>
          <div
            data-plasmic-name={"clients3"}
            data-plasmic-override={overrides.clients3}
            className={classNames(projectcss.all, sty.clients3)}
          >
            <div
              data-plasmic-name={"wrapper4"}
              data-plasmic-override={overrides.wrapper4}
              className={classNames(projectcss.all, sty.wrapper4)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mYwe3
                )}
              >
                {"Our Clients"}
              </div>
              <div
                data-plasmic-name={"rows2"}
                data-plasmic-override={overrides.rows2}
                className={classNames(projectcss.all, sty.rows2)}
              >
                <div
                  data-plasmic-name={"row3"}
                  data-plasmic-override={overrides.row3}
                  className={classNames(projectcss.all, sty.row3)}
                >
                  <div
                    data-plasmic-name={"_21"}
                    data-plasmic-override={overrides._21}
                    className={classNames(projectcss.all, sty._21)}
                  />

                  <div
                    data-plasmic-name={"_22"}
                    data-plasmic-override={overrides._22}
                    className={classNames(projectcss.all, sty._22)}
                  />

                  <div
                    data-plasmic-name={"_23"}
                    data-plasmic-override={overrides._23}
                    className={classNames(projectcss.all, sty._23)}
                  />

                  <div
                    data-plasmic-name={"_24"}
                    data-plasmic-override={overrides._24}
                    className={classNames(projectcss.all, sty._24)}
                  />
                </div>
                <div
                  data-plasmic-name={"row5"}
                  data-plasmic-override={overrides.row5}
                  className={classNames(projectcss.all, sty.row5)}
                >
                  <div
                    data-plasmic-name={"_25"}
                    data-plasmic-override={overrides._25}
                    className={classNames(projectcss.all, sty._25)}
                  />

                  <div
                    data-plasmic-name={"_26"}
                    data-plasmic-override={overrides._26}
                    className={classNames(projectcss.all, sty._26)}
                  />

                  <div
                    data-plasmic-name={"_27"}
                    data-plasmic-override={overrides._27}
                    className={classNames(projectcss.all, sty._27)}
                  />

                  <div
                    data-plasmic-name={"_28"}
                    data-plasmic-override={overrides._28}
                    className={classNames(projectcss.all, sty._28)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(hasVariant(globalVariants, "mobile", "mobile") ? true : false) ? (
        <div
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          className={classNames(projectcss.all, sty.mobile)}
        >
          <div
            data-plasmic-name={"banner2"}
            data-plasmic-override={overrides.banner2}
            className={classNames(projectcss.all, sty.banner2)}
          >
            <div
              data-plasmic-name={"sectionHeader2"}
              data-plasmic-override={overrides.sectionHeader2}
              className={classNames(projectcss.all, sty.sectionHeader2)}
            >
              <div
                data-plasmic-name={"top3"}
                data-plasmic-override={overrides.top3}
                className={classNames(projectcss.all, sty.top3)}
              >
                <h4
                  data-plasmic-name={"subtitle2"}
                  data-plasmic-override={overrides.subtitle2}
                  className={classNames(
                    projectcss.all,
                    projectcss.h4,
                    projectcss.__wab_text,
                    sty.subtitle2
                  )}
                >
                  {"The human approach to medical education"}
                </h4>
                <h1
                  data-plasmic-name={"title2"}
                  data-plasmic-override={overrides.title2}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.title2
                  )}
                >
                  {"Excellence beyond Compliance"}
                </h1>
              </div>
              <div
                data-plasmic-name={"body5"}
                data-plasmic-override={overrides.body5}
                className={classNames(projectcss.all, sty.body5)}
              >
                <p
                  data-plasmic-name={"body2"}
                  data-plasmic-override={overrides.body2}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.body2
                  )}
                >
                  {
                    "At MyEvaluations, cutting-edge technology with a human touch reshapes the way you manage medical education. "
                  }
                </p>
                <p
                  data-plasmic-name={"body6"}
                  data-plasmic-override={overrides.body6}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.body6
                  )}
                >
                  {
                    "Our intuitive suite of tools simplifies assessments, scheduling, curriculum management, and more, empowers you to achieve excellence in education."
                  }
                </p>
              </div>
            </div>
            <div
              data-plasmic-name={"actions2"}
              data-plasmic-override={overrides.actions2}
              className={classNames(projectcss.all, sty.actions2)}
            >
              <Button
                data-plasmic-name={"requestDemo2"}
                data-plasmic-override={overrides.requestDemo2}
                aria-label={"Request demo"}
                className={classNames("__wab_instance", sty.requestDemo2)}
                color={
                  hasVariant(globalVariants, "mobile", "mobile")
                    ? "primary"
                    : "primary"
                }
                link={
                  "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                }
                size={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "medium"
                    : "large"
                }
                target={true}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__w7Wlh
                  )}
                >
                  {"Request demo"}
                </div>
              </Button>
              <Button
                data-plasmic-name={"contact2"}
                data-plasmic-override={overrides.contact2}
                aria-label={"Open contact modal"}
                className={classNames("__wab_instance", sty.contact2)}
                color={"white"}
                onClick={async event => {
                  const $steps = {};

                  $steps["runOnContactClick"] = true
                    ? (() => {
                        const actionArgs = {
                          eventRef: $props["onContactClick"]
                        };
                        return (({ eventRef, args }) => {
                          return eventRef?.(...(args ?? []));
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runOnContactClick"] != null &&
                    typeof $steps["runOnContactClick"] === "object" &&
                    typeof $steps["runOnContactClick"].then === "function"
                  ) {
                    $steps["runOnContactClick"] =
                      await $steps["runOnContactClick"];
                  }
                }}
                size={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "medium"
                    : "large"
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ku6O4
                  )}
                >
                  {"Contact"}
                </div>
              </Button>
            </div>
          </div>
          <div
            data-plasmic-name={"clients2"}
            data-plasmic-override={overrides.clients2}
            className={classNames(projectcss.all, sty.clients2)}
          >
            <div
              data-plasmic-name={"top4"}
              data-plasmic-override={overrides.top4}
              className={classNames(projectcss.all, sty.top4)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__tsJ9B
                )}
              >
                {"Our Clients"}
              </div>
              <div
                data-plasmic-name={"row4"}
                data-plasmic-override={overrides.row4}
                className={classNames(projectcss.all, sty.row4)}
              >
                <div
                  data-plasmic-name={"left2"}
                  data-plasmic-override={overrides.left2}
                  className={classNames(projectcss.all, sty.left2)}
                >
                  <div
                    data-plasmic-name={"_13"}
                    data-plasmic-override={overrides._13}
                    className={classNames(projectcss.all, sty._13)}
                  />

                  <div
                    data-plasmic-name={"_15"}
                    data-plasmic-override={overrides._15}
                    className={classNames(projectcss.all, sty._15)}
                  />

                  <div
                    data-plasmic-name={"_17"}
                    data-plasmic-override={overrides._17}
                    className={classNames(projectcss.all, sty._17)}
                  />

                  <div
                    data-plasmic-name={"_19"}
                    data-plasmic-override={overrides._19}
                    className={classNames(projectcss.all, sty._19)}
                  />
                </div>
                <div
                  data-plasmic-name={"right2"}
                  data-plasmic-override={overrides.right2}
                  className={classNames(projectcss.all, sty.right2)}
                >
                  <div
                    data-plasmic-name={"_14"}
                    data-plasmic-override={overrides._14}
                    className={classNames(projectcss.all, sty._14)}
                  />

                  <div
                    data-plasmic-name={"_16"}
                    data-plasmic-override={overrides._16}
                    className={classNames(projectcss.all, sty._16)}
                  />

                  <div
                    data-plasmic-name={"_18"}
                    data-plasmic-override={overrides._18}
                    className={classNames(projectcss.all, sty._18)}
                  />

                  <div
                    data-plasmic-name={"_20"}
                    data-plasmic-override={overrides._20}
                    className={classNames(projectcss.all, sty._20)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  topSection: [
    "topSection",
    "desktop",
    "banner",
    "wrapper",
    "col",
    "sectionHeader",
    "top",
    "subtitle",
    "title",
    "body3",
    "body",
    "body4",
    "actions",
    "requestDemo",
    "contact",
    "desktopMockup",
    "clients",
    "wrapper2",
    "rows",
    "row",
    "_5",
    "_7",
    "_8",
    "_9",
    "row2",
    "_6",
    "_10",
    "_11",
    "_12",
    "tablet",
    "banner3",
    "wrapper3",
    "col2",
    "sectionHeader3",
    "top2",
    "subtitle3",
    "title3",
    "body7",
    "body8",
    "body9",
    "actions3",
    "requestDemo3",
    "contact3",
    "desktopMockup2",
    "clients3",
    "wrapper4",
    "rows2",
    "row3",
    "_21",
    "_22",
    "_23",
    "_24",
    "row5",
    "_25",
    "_26",
    "_27",
    "_28",
    "mobile",
    "banner2",
    "sectionHeader2",
    "top3",
    "subtitle2",
    "title2",
    "body5",
    "body2",
    "body6",
    "actions2",
    "requestDemo2",
    "contact2",
    "clients2",
    "top4",
    "row4",
    "left2",
    "_13",
    "_15",
    "_17",
    "_19",
    "right2",
    "_14",
    "_16",
    "_18",
    "_20"
  ],
  desktop: [
    "desktop",
    "banner",
    "wrapper",
    "col",
    "sectionHeader",
    "top",
    "subtitle",
    "title",
    "body3",
    "body",
    "body4",
    "actions",
    "requestDemo",
    "contact",
    "desktopMockup",
    "clients",
    "wrapper2",
    "rows",
    "row",
    "_5",
    "_7",
    "_8",
    "_9",
    "row2",
    "_6",
    "_10",
    "_11",
    "_12"
  ],
  banner: [
    "banner",
    "wrapper",
    "col",
    "sectionHeader",
    "top",
    "subtitle",
    "title",
    "body3",
    "body",
    "body4",
    "actions",
    "requestDemo",
    "contact",
    "desktopMockup"
  ],
  wrapper: [
    "wrapper",
    "col",
    "sectionHeader",
    "top",
    "subtitle",
    "title",
    "body3",
    "body",
    "body4",
    "actions",
    "requestDemo",
    "contact",
    "desktopMockup"
  ],
  col: [
    "col",
    "sectionHeader",
    "top",
    "subtitle",
    "title",
    "body3",
    "body",
    "body4",
    "actions",
    "requestDemo",
    "contact"
  ],
  sectionHeader: [
    "sectionHeader",
    "top",
    "subtitle",
    "title",
    "body3",
    "body",
    "body4"
  ],
  top: ["top", "subtitle", "title"],
  subtitle: ["subtitle"],
  title: ["title"],
  body3: ["body3", "body", "body4"],
  body: ["body"],
  body4: ["body4"],
  actions: ["actions", "requestDemo", "contact"],
  requestDemo: ["requestDemo"],
  contact: ["contact"],
  desktopMockup: ["desktopMockup"],
  clients: [
    "clients",
    "wrapper2",
    "rows",
    "row",
    "_5",
    "_7",
    "_8",
    "_9",
    "row2",
    "_6",
    "_10",
    "_11",
    "_12"
  ],
  wrapper2: [
    "wrapper2",
    "rows",
    "row",
    "_5",
    "_7",
    "_8",
    "_9",
    "row2",
    "_6",
    "_10",
    "_11",
    "_12"
  ],
  rows: [
    "rows",
    "row",
    "_5",
    "_7",
    "_8",
    "_9",
    "row2",
    "_6",
    "_10",
    "_11",
    "_12"
  ],
  row: ["row", "_5", "_7", "_8", "_9"],
  _5: ["_5"],
  _7: ["_7"],
  _8: ["_8"],
  _9: ["_9"],
  row2: ["row2", "_6", "_10", "_11", "_12"],
  _6: ["_6"],
  _10: ["_10"],
  _11: ["_11"],
  _12: ["_12"],
  tablet: [
    "tablet",
    "banner3",
    "wrapper3",
    "col2",
    "sectionHeader3",
    "top2",
    "subtitle3",
    "title3",
    "body7",
    "body8",
    "body9",
    "actions3",
    "requestDemo3",
    "contact3",
    "desktopMockup2",
    "clients3",
    "wrapper4",
    "rows2",
    "row3",
    "_21",
    "_22",
    "_23",
    "_24",
    "row5",
    "_25",
    "_26",
    "_27",
    "_28"
  ],
  banner3: [
    "banner3",
    "wrapper3",
    "col2",
    "sectionHeader3",
    "top2",
    "subtitle3",
    "title3",
    "body7",
    "body8",
    "body9",
    "actions3",
    "requestDemo3",
    "contact3",
    "desktopMockup2"
  ],
  wrapper3: [
    "wrapper3",
    "col2",
    "sectionHeader3",
    "top2",
    "subtitle3",
    "title3",
    "body7",
    "body8",
    "body9",
    "actions3",
    "requestDemo3",
    "contact3",
    "desktopMockup2"
  ],
  col2: [
    "col2",
    "sectionHeader3",
    "top2",
    "subtitle3",
    "title3",
    "body7",
    "body8",
    "body9",
    "actions3",
    "requestDemo3",
    "contact3"
  ],
  sectionHeader3: [
    "sectionHeader3",
    "top2",
    "subtitle3",
    "title3",
    "body7",
    "body8",
    "body9"
  ],
  top2: ["top2", "subtitle3", "title3"],
  subtitle3: ["subtitle3"],
  title3: ["title3"],
  body7: ["body7", "body8", "body9"],
  body8: ["body8"],
  body9: ["body9"],
  actions3: ["actions3", "requestDemo3", "contact3"],
  requestDemo3: ["requestDemo3"],
  contact3: ["contact3"],
  desktopMockup2: ["desktopMockup2"],
  clients3: [
    "clients3",
    "wrapper4",
    "rows2",
    "row3",
    "_21",
    "_22",
    "_23",
    "_24",
    "row5",
    "_25",
    "_26",
    "_27",
    "_28"
  ],
  wrapper4: [
    "wrapper4",
    "rows2",
    "row3",
    "_21",
    "_22",
    "_23",
    "_24",
    "row5",
    "_25",
    "_26",
    "_27",
    "_28"
  ],
  rows2: [
    "rows2",
    "row3",
    "_21",
    "_22",
    "_23",
    "_24",
    "row5",
    "_25",
    "_26",
    "_27",
    "_28"
  ],
  row3: ["row3", "_21", "_22", "_23", "_24"],
  _21: ["_21"],
  _22: ["_22"],
  _23: ["_23"],
  _24: ["_24"],
  row5: ["row5", "_25", "_26", "_27", "_28"],
  _25: ["_25"],
  _26: ["_26"],
  _27: ["_27"],
  _28: ["_28"],
  mobile: [
    "mobile",
    "banner2",
    "sectionHeader2",
    "top3",
    "subtitle2",
    "title2",
    "body5",
    "body2",
    "body6",
    "actions2",
    "requestDemo2",
    "contact2",
    "clients2",
    "top4",
    "row4",
    "left2",
    "_13",
    "_15",
    "_17",
    "_19",
    "right2",
    "_14",
    "_16",
    "_18",
    "_20"
  ],
  banner2: [
    "banner2",
    "sectionHeader2",
    "top3",
    "subtitle2",
    "title2",
    "body5",
    "body2",
    "body6",
    "actions2",
    "requestDemo2",
    "contact2"
  ],
  sectionHeader2: [
    "sectionHeader2",
    "top3",
    "subtitle2",
    "title2",
    "body5",
    "body2",
    "body6"
  ],
  top3: ["top3", "subtitle2", "title2"],
  subtitle2: ["subtitle2"],
  title2: ["title2"],
  body5: ["body5", "body2", "body6"],
  body2: ["body2"],
  body6: ["body6"],
  actions2: ["actions2", "requestDemo2", "contact2"],
  requestDemo2: ["requestDemo2"],
  contact2: ["contact2"],
  clients2: [
    "clients2",
    "top4",
    "row4",
    "left2",
    "_13",
    "_15",
    "_17",
    "_19",
    "right2",
    "_14",
    "_16",
    "_18",
    "_20"
  ],
  top4: [
    "top4",
    "row4",
    "left2",
    "_13",
    "_15",
    "_17",
    "_19",
    "right2",
    "_14",
    "_16",
    "_18",
    "_20"
  ],
  row4: [
    "row4",
    "left2",
    "_13",
    "_15",
    "_17",
    "_19",
    "right2",
    "_14",
    "_16",
    "_18",
    "_20"
  ],
  left2: ["left2", "_13", "_15", "_17", "_19"],
  _13: ["_13"],
  _15: ["_15"],
  _17: ["_17"],
  _19: ["_19"],
  right2: ["right2", "_14", "_16", "_18", "_20"],
  _14: ["_14"],
  _16: ["_16"],
  _18: ["_18"],
  _20: ["_20"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  topSection: "section";
  desktop: "div";
  banner: "div";
  wrapper: "div";
  col: "div";
  sectionHeader: "header";
  top: "div";
  subtitle: "h4";
  title: "h1";
  body3: "div";
  body: "p";
  body4: "p";
  actions: "div";
  requestDemo: typeof Button;
  contact: typeof Button;
  desktopMockup: typeof PlasmicImg__;
  clients: "div";
  wrapper2: "div";
  rows: "div";
  row: "div";
  _5: "div";
  _7: "div";
  _8: "div";
  _9: "div";
  row2: "div";
  _6: "div";
  _10: "div";
  _11: "div";
  _12: "div";
  tablet: "div";
  banner3: "div";
  wrapper3: "div";
  col2: "div";
  sectionHeader3: "div";
  top2: "div";
  subtitle3: "h4";
  title3: "h1";
  body7: "div";
  body8: "p";
  body9: "p";
  actions3: "div";
  requestDemo3: typeof Button;
  contact3: typeof Button;
  desktopMockup2: typeof PlasmicImg__;
  clients3: "div";
  wrapper4: "div";
  rows2: "div";
  row3: "div";
  _21: "div";
  _22: "div";
  _23: "div";
  _24: "div";
  row5: "div";
  _25: "div";
  _26: "div";
  _27: "div";
  _28: "div";
  mobile: "div";
  banner2: "div";
  sectionHeader2: "div";
  top3: "div";
  subtitle2: "h4";
  title2: "h1";
  body5: "div";
  body2: "p";
  body6: "p";
  actions2: "div";
  requestDemo2: typeof Button;
  contact2: typeof Button;
  clients2: "div";
  top4: "div";
  row4: "div";
  left2: "div";
  _13: "div";
  _15: "div";
  _17: "div";
  _19: "div";
  right2: "div";
  _14: "div";
  _16: "div";
  _18: "div";
  _20: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeTopSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeTopSection__VariantsArgs;
    args?: PlasmicHomeTopSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeTopSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeTopSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeTopSection__ArgProps,
          internalVariantPropNames: PlasmicHomeTopSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeTopSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "topSection") {
    func.displayName = "PlasmicHomeTopSection";
  } else {
    func.displayName = `PlasmicHomeTopSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeTopSection = Object.assign(
  // Top-level PlasmicHomeTopSection renders the root element
  makeNodeComponent("topSection"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    banner: makeNodeComponent("banner"),
    wrapper: makeNodeComponent("wrapper"),
    col: makeNodeComponent("col"),
    sectionHeader: makeNodeComponent("sectionHeader"),
    top: makeNodeComponent("top"),
    subtitle: makeNodeComponent("subtitle"),
    title: makeNodeComponent("title"),
    body3: makeNodeComponent("body3"),
    body: makeNodeComponent("body"),
    body4: makeNodeComponent("body4"),
    actions: makeNodeComponent("actions"),
    requestDemo: makeNodeComponent("requestDemo"),
    contact: makeNodeComponent("contact"),
    desktopMockup: makeNodeComponent("desktopMockup"),
    clients: makeNodeComponent("clients"),
    wrapper2: makeNodeComponent("wrapper2"),
    rows: makeNodeComponent("rows"),
    row: makeNodeComponent("row"),
    _5: makeNodeComponent("_5"),
    _7: makeNodeComponent("_7"),
    _8: makeNodeComponent("_8"),
    _9: makeNodeComponent("_9"),
    row2: makeNodeComponent("row2"),
    _6: makeNodeComponent("_6"),
    _10: makeNodeComponent("_10"),
    _11: makeNodeComponent("_11"),
    _12: makeNodeComponent("_12"),
    tablet: makeNodeComponent("tablet"),
    banner3: makeNodeComponent("banner3"),
    wrapper3: makeNodeComponent("wrapper3"),
    col2: makeNodeComponent("col2"),
    sectionHeader3: makeNodeComponent("sectionHeader3"),
    top2: makeNodeComponent("top2"),
    subtitle3: makeNodeComponent("subtitle3"),
    title3: makeNodeComponent("title3"),
    body7: makeNodeComponent("body7"),
    body8: makeNodeComponent("body8"),
    body9: makeNodeComponent("body9"),
    actions3: makeNodeComponent("actions3"),
    requestDemo3: makeNodeComponent("requestDemo3"),
    contact3: makeNodeComponent("contact3"),
    desktopMockup2: makeNodeComponent("desktopMockup2"),
    clients3: makeNodeComponent("clients3"),
    wrapper4: makeNodeComponent("wrapper4"),
    rows2: makeNodeComponent("rows2"),
    row3: makeNodeComponent("row3"),
    _21: makeNodeComponent("_21"),
    _22: makeNodeComponent("_22"),
    _23: makeNodeComponent("_23"),
    _24: makeNodeComponent("_24"),
    row5: makeNodeComponent("row5"),
    _25: makeNodeComponent("_25"),
    _26: makeNodeComponent("_26"),
    _27: makeNodeComponent("_27"),
    _28: makeNodeComponent("_28"),
    mobile: makeNodeComponent("mobile"),
    banner2: makeNodeComponent("banner2"),
    sectionHeader2: makeNodeComponent("sectionHeader2"),
    top3: makeNodeComponent("top3"),
    subtitle2: makeNodeComponent("subtitle2"),
    title2: makeNodeComponent("title2"),
    body5: makeNodeComponent("body5"),
    body2: makeNodeComponent("body2"),
    body6: makeNodeComponent("body6"),
    actions2: makeNodeComponent("actions2"),
    requestDemo2: makeNodeComponent("requestDemo2"),
    contact2: makeNodeComponent("contact2"),
    clients2: makeNodeComponent("clients2"),
    top4: makeNodeComponent("top4"),
    row4: makeNodeComponent("row4"),
    left2: makeNodeComponent("left2"),
    _13: makeNodeComponent("_13"),
    _15: makeNodeComponent("_15"),
    _17: makeNodeComponent("_17"),
    _19: makeNodeComponent("_19"),
    right2: makeNodeComponent("right2"),
    _14: makeNodeComponent("_14"),
    _16: makeNodeComponent("_16"),
    _18: makeNodeComponent("_18"),
    _20: makeNodeComponent("_20"),

    // Metadata about props expected for PlasmicHomeTopSection
    internalVariantProps: PlasmicHomeTopSection__VariantProps,
    internalArgProps: PlasmicHomeTopSection__ArgProps
  }
);

export default PlasmicHomeTopSection;
/* prettier-ignore-end */
